import axios from 'axios';

/**
 * Queries logs from the analytics API
 * @param {string} from - Start date for query
 * @param {string} to - End date for query
 * @param {string} eventName - Event name to filter by
 * @param {object} payload - Additional query parameters
 * @returns {Promise} - Axios response or mock data if not in development
 */
export async function queryLogs(from, to, eventName, payload = {}) {
  try {
    const response = await axios.post(
      'https://yqpd9l2hjh.execute-api.us-west-2.amazonaws.com/dev/queryLogs',
      {
        from,
        to,
        eventName,
        payload
      }
    );
    return response;
  } catch (error) {
    console.error('Error querying logs:', error);
    return { data: { results: [] } };
  }
}

export async function queryAnalyticsCounts(params) {
  return axios.get(
    'https://yqpd9l2hjh.execute-api.us-west-2.amazonaws.com/dev/queryLogs',
    {
      params: { ...params, interval: 'day' }
    }
  );
}
